import * as WebAuthnJSON from '@github/webauthn-json'

const getCredential = (credentialOptions) => {
  WebAuthnJSON.get({ publicKey: credentialOptions }).then(function (credential) {
    const token = document.querySelector('meta[name="csrf-token"]').content
    fetch('/mfa/webauthn', {
      method: 'POST',
      body: JSON.stringify({
        // eslint-disable-next-line no-undef
        channel,
        origin: window.location.origin,
        publicKeyCredential: JSON.stringify(credential)
      }),
      headers: {
        'X-CSRF-Token': token,
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin'
    }).then(response => {
      if (response.ok) {
        // Faye handles approved mfa but go to callback path here after 3 seconds in case Faye message is lost.
        setTimeout(function () {
          // eslint-disable-next-line no-undef
          window.location.replace(callBackPath)
        }, 3000)
      } else {
        setError('verification_failed')
      }
    })
  }).catch(function (error) {
    console.error('Credential Error: ', error)
    setError('verification_failed')
  })
}

const setError = (code) => {
  // eslint-disable-next-line no-undef
  window.location.replace(`${window.location.origin}/mfa/webauthn/fail?code=${code}&channel=${channel}`)
}

const startWebAuthnFlow = () => {
  if (!WebAuthnJSON.supported()) {
    setError('browser_not_supported')
    return
  }
  // eslint-disable-next-line no-undef
  fetch(`/mfa/webauthn?channel=${channel}&origin=${encodeURIComponent(window.location.origin)}`).then(response => {
    response.json().then(function (data) {
      getCredential(data.options)
    })
  })
}

const addWebAuthnEventListener = () => {
  const button = document.getElementById('webauthn-button')
  if (!button) {
    return
  }

  button.addEventListener('click', startWebAuthnFlow, { once: true })
}

/* global translations */

const startWebAuthnFlowWithoutUsername = async (challenge, userVerification, domain) => {
  const loader = document.getElementById('loading-spinner')
  const loginMethodsDivs = document.querySelectorAll('.login-section')
  let webAuthnSuccess = false

  try {
    const abortController = new AbortController()

    const publicKeyCredentialRequestOptions = {
      challenge,
      rpId: domain,
      userVerification
    }

    const credential = await WebAuthnJSON.get({
      publicKey: publicKeyCredentialRequestOptions,
      signal: abortController.signal
    })

    if (!credential) {
      console.info('No WebAuthn credential found, using normal login flow.')
      return
    }

    loader.classList.remove('d-none')
    loader.classList.add('d-block')
    loginMethodsDivs.forEach(div => div.classList.add('d-none'))

    const response = await fetch('sign_in/webauthn', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
      },
      body: JSON.stringify({ credential })
    })

    if (response.ok) {
      const resp = await response.json()
      window.location.href = resp.path
      webAuthnSuccess = true
    } else {
      const resp = await response.json()
      showRailsAlert(resp.error)
    }
  } catch (error) {
    if (error.name === 'NotAllowedError') {
      console.log(error)
      showRailsAlert(translations.current.discoverable_passkey_not_enabled)
      return
    }
    console.error('WebAuthn authentication failed:', error)
  } finally {
    if (!webAuthnSuccess) {
      loader.classList.remove('d-block')
      loader.classList.add('d-none')
      loginMethodsDivs.forEach(div => div.classList.remove('d-none'))
    }
  }
}

const showRailsAlert = (message) => {
  const alert = document.getElementById('alert-msg')
  alert.innerText = message
  document.getElementById('alert-box').classList.add('show')
  document.getElementById('alerts-container').classList.remove('d-none')
}

const detectWebAuthn = async (challenge, userVerification, domain) => {
  // Ensure WebAuthn is supported on the browser
  if (!WebAuthnJSON.supported()) {
    showRailsAlert(translations.current.passkey_browser_not_supported)
    return
  }

  try {
    await startWebAuthnFlowWithoutUsername(challenge, userVerification, domain)
  } catch (error) {
    console.error('WebAuthn authentication failed:', error)
  }
}

window.detectWebAuthn = detectWebAuthn
window.addWebAuthnEventListener = addWebAuthnEventListener
